import axios from './axios.config';

const travelExpenseReportsAPI = {
    // Get travel requests that can have expense reports (cache-bust so dropdown always gets fresh data)
    getTravelRequestsForExpenseReports: () => {
        return axios.get('/travel/expense-reports/travel/requests', {
            params: { _t: Date.now() },
        });
    },

    // Get expense reports with travel data
    getExpenseReportsWithTravelData: (params = {}) => {
        return axios.get('/travel/expense-reports/travel/reports', { params });
    },

    // Create expense report from travel data
    createExpenseReportFromTravel: (data) => {
        return axios.post('/travel/expense-reports/travel/create', data);
    },

    // Get expense report summary for a travel advance (price tracking when adding another report)
    getExpenseReportSummaryByAdvance: (advanceId) => {
        return axios.get(`/travel/expense-reports/by-advance/${advanceId}/summary`);
    },

    // Get all expense reports (existing)
    getAllExpenseReports: (params = {}) => {
        return axios.get('/travel/expense-reports', { params });
    },

    // Get expense report by ID
    getExpenseReportById: (id) => {
        return axios.get(`/travel/expense-reports/${id}`);
    },

    // Update expense report
    updateExpenseReport: (id, data) => {
        return axios.put(`/travel/expense-reports/${id}`, data);
    },

    // Submit expense report for approval
    submitExpenseReport: (id) => {
        return axios.post(`/travel/expense-reports/${id}/submit`);
    },

    // Approve expense report
    approveExpenseReport: (id, data) => {
        return axios.put(`/travel/expense-reports/${id}/approve`, data);
    },

    // Reject expense report
    rejectExpenseReport: (id, data) => {
        return axios.put(`/travel/expense-reports/${id}/reject`, data);
    },

    // Get expense report approval queue (params._t for cache-bust after approve)
    getExpenseReportApprovalQueue: (params = {}) => {
        return axios.get('/travel/expense-reports/approval-queue', { params: { ...params, _t: params._t ?? Date.now() } });
    },

    // Resubmit rejected expense report
    resubmitExpenseReport: (id) => {
        return axios.put(`/travel/expense-reports/${id}/resubmit`);
    },
};

export default travelExpenseReportsAPI; 